module.exports = __webpack_public_path__ + "img/order-cancel.4eaac1e1.png";